export const hamburger = () => {
  const icnMenu = document.querySelector('.menu-icon');
  icnMenu.addEventListener('click', () => {
    icnMenu.classList.toggle('active');
  });
 }
 